
















































































































































































































































































































































import {
	AccountTypeEnum,
	BillingModel,
	PatchBatchDocument,
	PredicateDefinition,
	QueryOperator,
	TenantUserModel, TransactionEmailType
} from '@/libs/Api';
import ExportDialog from '@/libs/common/components-smart/ExportDialog.vue';
import {CrudAction, CrudReponse} from '@/libs/core/+state/models/crud-action';
import {CrudDataStats} from '@/libs/core/+state/models/crud-data-stats';
import {CrudGetter} from '@/libs/core/+state/models/crud-getter';
import {createCrudQueryPayload} from '@/libs/core/+state/models/crud-query-payload';
import {CrudQueryPredicate} from '@/libs/core/+state/models/crud-query-predicate';
import {billingsStore} from '@/libs/billings/+state/store';
import Page from '@/Page.vue';
import moment from 'moment';
import {Component, Prop, Ref, Watch} from 'vue-property-decorator';
import {authStore} from '@/libs/auth/+store/store';
import {AuthGetter} from '@/libs/auth/models/auth-state';
import {CrudOrderBy} from '@/libs/core/+state/models/crud-order-by';
import BillingCreateDialog from '../components/BillingCreateDialog.vue';
import {createAggregationQueryPayload} from "@/libs/core/+state/models/aggregation-query-payload";
import {useObjectKey} from "@/libs/common/functions/use-object-key";
import ReportDialogBillings from "@/libs/billings/components/ReportDialogBillings.vue";
import ReportDialogReceipts from "@/libs/billings/components/ReportDialogReceipts.vue";
import ReportDialogBillingByWorkTasks from "@/libs/billings/components/ReportDialogBillingByWorkTasks.vue";
import ReportDialogPaymentPrescriptions from "@/libs/billings/components/ReportDialogPaymentPrescriptions.vue";
import ReportDialogDebts from "@/libs/billings/components/ReportDialogDebts.vue";
import {BillingActionEnum} from "@/libs/billings/model/BillingActionEnum";
import ApiService from "@/libs/core/api-service";
import {Guid} from "@/libs/common/functions/guid";
import { Filters, PageFilter } from '@/filters';
import { DateRangeValue } from '@/libs/common/components/DateRangePicker.vue';

@Component({
	computed: {
		BillingActionEnum() {
			return BillingActionEnum
		}
	},
    components: {
		ReportDialogDebts,
		ReportDialogPaymentPrescriptions,
		ReportDialogBillingByWorkTasks,
		ReportDialogReceipts,
		ReportDialogBillings,
        BillingCreateDialog
    }
})
export default class Statements extends Page {
    
    filterStart: DateRangeValue | null = null;
    filterParty: string | null = "";
	filterTown: string | null = "";
	filterDistrict: string | null = "";
    pageInitialization = true;
    mobileFiltersShow = false;
    pageIndex = 1;
    pageSize = 25;
    sortBy = [ "fromDate" ];
    sortDesc = [ true ];
	printing = false;
    selected: BillingModel[] = [];

    get headers() {
        return [
            { text: "Období", value: "fromDate", align: "left", width: "7%" },
            { text: this.$i18n.t("statements.columnClient"), value: "party.lastName", align: "left" },
            { text: "E-mail", value: "party.emailAddress", align: "left" },
			{ text: "Celkem k zaplacení", value: "totalAmount", align: "left", width: "7%" },
			{ text: "Celkem zaplaceno", value: "paidAmount", align: "left", width: "7%" },
			{ text: "Uzamčeno", value: "isLocked", align: "left", width: "7%" },
			{ text: "Odesláno vyúčtování", value: "billingIsSentToClient", align: "left", width: "7%" },
			{ text: "Odeslána stvrzenka", value: "receiptIsSentToClient", align: "left", width: "7%" },
			{ text: "Zaplaceno", value: "isPaid", align: "left", width: "7%" },
            { text: "", value: "id", align: "left", width: "10%" },
        ];
    }

    @Prop() tenantId!: string;
    @Prop() partyId!: string;

    @Ref() createDialog!: BillingCreateDialog;
    @Ref() exportDialog!: ExportDialog;
    @Ref() reportDialogBillings!: ReportDialogBillings;
    @Ref() reportDialogReceipts!: ReportDialogReceipts;
    @Ref() reportDialogPaymentPrescriptions!: ReportDialogPaymentPrescriptions;
    @Ref() reportDialogBillingByWorkTasks!: ReportDialogBillingByWorkTasks;
    @Ref() reportDialogDebts!: ReportDialogDebts;

    @Watch("filterStart")
    @Watch("filterParty")
	@Watch("filterTown")
	@Watch("filterDistrict")
    filtersChanged () {
        this.saveQuery();
        if (this.pageInitialization || this.isPageLocked())
            return;
		this.selected = [];
        this.pageLock(this.$nextTick()).then(() => {
            this.pageIndex = 1;
            this.load();
        });
    }

    @Watch("pageIndex")
    @Watch("pageSize")
    paginationChanged () {
        if (this.pageInitialization || this.isPageLocked())
            return;
		this.selected = [];
        this.pageLock(this.$nextTick()).then(() => {
            this.load();
        });
    }

    @Watch("pageSize")
    pageSizeChanged () {
        this.pageIndex = 1;
    }

    get billings () {
        return [...billingsStore.useGetter(CrudGetter.Data)];
    }

    get totalRows (): number {
        return ({...billingsStore.useGetter(CrudGetter.DataStats)} as CrudDataStats)?.rowCount;
    }

    get exporting(): boolean {
        return billingsStore.useGetter(CrudGetter.Downloading);
    }

    get isAdmin (): boolean {
        const tenantUser = authStore.useGetter(AuthGetter.GetTenantUser) as TenantUserModel;
        return tenantUser.accountType == AccountTypeEnum.Admin;
    }

    get loading () {
        return billingsStore.useGetter(CrudGetter.Pending);
    }

    get billingTotalAmount () {
        return billingsStore.useGetter(CrudGetter.Sum, 'BillingTotalAmount');
    }

    get billingPaidAmount () {
        return billingsStore.useGetter(CrudGetter.Sum, 'BillingPaidAmount');
    }

	get isAllSelected(): boolean {
		const billings = [...billingsStore.useGetter(CrudGetter.Data)];
		return (this.selected.count() > 0 && this.selected.count() >= billings.count()) || this.selected.count() == 0;
	}

	@Watch("sortBy")
    @Watch("sortDesc")
    sortChanged () {
        if (this.pageInitialization || this.isPageLocked())
            return;
        this.pageLock(this.$nextTick()).then(() => {
            this.load();
        });
    }

    created () {
        if (this.getQuery("start") != null || this.getQuery("end") != null || this.getQuery("state") != null || this.getQuery("party") != null || this.getQuery("user") != null || this.getQuery("district") != null || this.getQuery("town") != null || this.getQuery("paymentMethod") != null || this.getQuery("type") != null || this.getQueryInt("pageSize") != null) {
            if (moment(this.getQuery("start")).isValid() && moment(this.getQuery("end")).isValid() && this.getQuery("datetype") == "period") {
                this.filterStart = {
                    type: 'period',
                    fromDate: moment(this.getQuery("start")).format("YYYY-MM-DDT00:00:00"),
                    toDate: moment(this.getQuery("end")).format("YYYY-MM-DDT23:59:59")
                };
            }
            else if (moment(this.getQuery("start")).isValid() && moment(this.getQuery("end")).isValid() && this.getQuery("datetype") == "range") {
                this.filterStart = {
                    type: 'range',
                    fromDate: moment(this.getQuery("start")).format("YYYY-MM-DDT00:00:00"),
                    toDate: moment(this.getQuery("end")).format("YYYY-MM-DDT23:59:59")
                };
            }
            this.filterParty = this.getQuery("party") ?? "";
            this.filterDistrict = this.getQuery("district") ?? "";
            this.filterTown = this.getQuery("town") ?? "";
            this.pageSize = this.getQueryInt("pageSize") ?? 25;
        }
        else {
            if (moment(Filters.loadFilter('Global', 'start')).isValid() && moment(Filters.loadFilter('Global', 'end')).isValid() && Filters.loadFilter('Global', 'datetype') == "period") {
                this.filterStart = {
                    type: 'period',
                    fromDate: moment(Filters.loadFilter('Global', 'start')).format("YYYY-MM-DDT00:00:00"),
                    toDate: moment(Filters.loadFilter('Global', 'end')).format("YYYY-MM-DDT23:59:59")
                };
            }
            else if (moment(Filters.loadFilter('Global', 'start')).isValid() && moment(Filters.loadFilter('Global', 'end')).isValid() && Filters.loadFilter('Global', 'datetype') == "range") {
                this.filterStart = {
                    type: 'range',
                    fromDate: moment(Filters.loadFilter('Global', 'start')).format("YYYY-MM-DDT00:00:00"),
                    toDate: moment(Filters.loadFilter('Global', 'end')).format("YYYY-MM-DDT23:59:59")
                };
            }
            this.filterParty = Filters.loadFilter('Billings', 'party') ?? null;
            this.filterDistrict = Filters.loadFilter('Billings', 'district') ?? null;
            this.filterTown = Filters.loadFilter('Billings', 'town') ?? null;
            this.pageSize = Number(Filters.loadFilter('Billings', 'pageSize', '25')) ?? 25;
            this.saveQuery();
        }
    }

    mounted () {
        this.load();
    }

    saveQuery () {
        this.setQuery("datetype", this.filterStart?.type ?? null);
        this.setQuery("start", moment(this.filterStart?.fromDate).format("YYYY-MM-DD"));
        this.setQuery("end", moment(this.filterStart?.toDate).format("YYYY-MM-DD"));
        this.setQuery("party", this.filterParty);
        this.setQuery("district", this.filterDistrict);
        this.setQuery("town", this.filterTown);
        this.setQuery("pageSize", this.pageSize?.toString());
        const filters: PageFilter = {
            pageName: 'Billings',
            filters: [
                { name: 'party', value: this.filterParty },
                { name: 'district', value: this.filterDistrict },
                { name: 'town', value: this.filterTown },
                { name: 'pageSize', value: this.pageSize > 0 ? this.pageSize : 25 }
            ]
        };
        Filters.saveFilters(filters);
        const globalFilters: PageFilter = {
            pageName: 'Global',
            filters: [
                { name: 'datetype', value: this.filterStart?.type ?? null },
                { name: 'start', value: moment(this.filterStart?.fromDate).format("YYYY-MM-DD") },
                { name: 'end', value: moment(this.filterStart?.toDate).format("YYYY-MM-DD") },
            ]
        };
        Filters.saveFilters(globalFilters);
    }

    clearFilters () {
        this.filterStart = {
            type: "period",
            fromDate: moment().add(-1, "month").startOf("month").format("YYYY-MM-DDT00:00:00"),
            toDate: moment().add(-1, "month").endOf("month").format("YYYY-MM-DDT23:59:59")
        };
        this.filterParty = null;
		if (this.isAdmin) {
			this.filterDistrict = null;
		}
		this.filterTown = null;
    }

    load () {
        const orderBy: CrudOrderBy<BillingModel>[] = [];
        if (this.sortBy.length == 0) {
            orderBy.push({
                field: "fromDate",
                index: 1,
                order: "desc"
            });
        }
        else {
            orderBy.push({
                field: this.sortBy.first(),
                index: 1,
                order: this.sortDesc.first() ? "desc" : "asc"
            });
        }
        billingsStore.dispatch(CrudAction.GetAll, createCrudQueryPayload<BillingModel>(orderBy, this.getFilters(), {
            pageIndex: this.pageIndex,
            pageSize: this.pageSize
        }));
        this.subscribe(billingsStore, CrudReponse.GetAll).then(() => {
            this.pageInitialization = false;
        });
		this.loadSum();
    }

	loadSum() {
		const filters = this.getFilters();
		billingsStore.dispatch(CrudAction.GetSum, createAggregationQueryPayload(filters, useObjectKey<BillingModel>("totalAmount"), "BillingTotalAmount"));
		billingsStore.dispatch(CrudAction.GetSum, createAggregationQueryPayload(filters, useObjectKey<BillingModel>("paidAmount"), "BillingPaidAmount"));
	}

    getFilters(includeSelectionFilter = false): CrudQueryPredicate[] {

        let filters: CrudQueryPredicate[] = [];
        
        if (this.filterStart?.fromDate) {
            filters.push({
                field: "fromDate",
                op: QueryOperator.Lte,
                comparand: moment(this.filterStart.fromDate).format("YYYY-MM-DDT00:00:00")
            });
        }
        
        if (this.filterStart?.toDate) {
            filters.push({
                field: "toDate",
                op: QueryOperator.Gte,
                comparand: moment(this.filterStart.toDate).format("YYYY-MM-DDT23:59:59")
            });
        }
        
        // if (this.filterStart) {
        //     filters.push({ field: "fromDate", op: "lt", comparand: moment(this.filterStart).endOf("month").format("YYYY-MM-DDT00:00:00") });
        //     filters.push({ field: "toDate", op: "gt", comparand: moment(this.filterStart).format("YYYY-MM-DDT23:59:59") });
        // }
        
        if (this.filterParty) 
            filters.push({ field: "partyId", op: "eq", comparand: this.filterParty });

		if (this.filterDistrict) {
			filters.push({ field: "party.districtId", op: "eq", comparand: this.filterDistrict });
			if (this.filterTown) {
				filters.push({ field: "party.townId", op: "eq", comparand: this.filterTown });
			}
		}

		if (includeSelectionFilter) {

			const items = [...billingsStore.useGetter(CrudGetter.Data)];
			const selected = this.selected;

			if (selected.count() < items.count() && selected.count() > 0) {
				filters.push({
					field: "id",
					op: QueryOperator.In,
					comparand: selected.select(x => x.id!).toArray()
				});
			}

		}

        return filters;

    }

    getPayload() {
        return createCrudQueryPayload<BillingModel>({ field: "fromDate", index: 1, order: "desc"}, this.getFilters(true));
    }

    printBillingsClick () {
        this.reportDialogBillings.open(this.filterStart!.fromDate!, this.filterStart!.toDate!, this.getFilters(true) as PredicateDefinition[]);
    }

	printReceiptsClick () {
		this.reportDialogReceipts.open(this.filterStart!.fromDate!, this.filterStart!.toDate!, this.getFilters(true) as PredicateDefinition[]);
    }

    printReportPaymentPrescriptionsClick () {
        this.reportDialogPaymentPrescriptions.open(this.filterStart!.fromDate!, this.filterStart!.toDate!, this.getFilters(true) as PredicateDefinition[]);
    }

    printBillingByWorkTasksClick () {
        this.reportDialogBillingByWorkTasks.open(this.filterStart!.fromDate!, this.filterStart!.toDate!, this.getFilters(true) as PredicateDefinition[]);
    }

    printBillingDebtsClick () {
        this.reportDialogDebts.open(this.filterStart!.fromDate!, this.filterStart!.toDate!, this.getFilters() as PredicateDefinition[]);
    }

    exportDownload () {
        billingsStore.dispatch(CrudAction.Download, this.getPayload());
        this.subscribe(billingsStore, CrudReponse.Download).then(() => {
            this.exportDialog.close();
        });
    }

    createBilling () {
        this.createDialog.open();
    }

	makeBillingActionClick(action: BillingActionEnum) {
		const documentList: PatchBatchDocument[] = [
			{
				id: Guid.EmptyGuid(),
				query: this.getFilters(true) as any,
				operations: []
			}
		];
		ApiService.api.patchBatchBilling(documentList, {
			headers: {
				"Action": action
			}
		}).then((req: any) => {
			const response = req.data.returnValue;
			this.load();
		});
	}

	getBillingIsSending(item: BillingModel) {
		return item.transactionEmails!.any(x => x.type == TransactionEmailType.Billing && x.isSent == false);
	}

	getReceiptIsSending(item: BillingModel) {
		return item.transactionEmails!.any(x => x.type == TransactionEmailType.Receipt && x.isSent == false);
	}

}
